import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  const skills = [{
    category: 'Technical',
    items: ['Claude Code', 'Google AI Studio', 'VSCode', 'Cursor', 'Prompt Engineering', 'LLM Evals', 'A/B Experimentation']
  }, {
    category: 'Soft Skills',
    items: ['Cross-functional Leadership', 'Product Strategy', 'User Empathy', '0-to-1 Execution', 'Stakeholder Alignment']
  }, {
    category: 'Domain Expertise',
    items: ['AI/Voice UX', 'Browser Products', 'LLM Evaluation', 'E-commerce/SMB', 'Emerging Markets', 'Accessibility']
  }];
  return <div className="max-w-4xl mx-auto px-6 pt-24 pb-24" data-id="element-78">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-79">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-12" data-id="element-80">
          About Me
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-16" data-id="element-81">
          <div className="md:col-span-7 space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-82">
            <p data-id="element-83">
              I'm currently a Product Manager at Microsoft AI, where I focus on
              driving the development cycle for AI consumer products used by
              millions of users globally.
            </p>
            <p data-id="element-84">
              With 5 years of experience in product management, I've developed a
              deep specialization in Voice products and LLM evaluation. I thrive
              in 0-to-1 environments, taking ambiguous problems and turning them
              into shipped, metric-driven solutions.
            </p>
            <p data-id="element-85">
              My approach is deeply analytical yet user-centric. Whether it's
              doubling D7 retention for a Voice product through rigorous prompt
              engineering, or building an LLM evaluation framework from scratch
              to reduce customer dissatisfaction, I believe in measuring what
              matters.
            </p>
            <p data-id="element-86">
              Beyond my corporate work, I'm passionate about democratizing
              technology. I founded SheCodes Vietnam from scratch, growing it to
              a 10,000+ member community to provide tech education for girls, an
              effort recognized by UN Women.
            </p>
          </div>

          <div className="md:col-span-5" data-id="element-87">
            <div className="aspect-square bg-gray-100 rounded-3xl overflow-hidden mb-8 relative" data-id="element-88">
              {/* Placeholder for headshot */}
              <div className="absolute inset-0 flex items-center justify-center text-gray-400" data-id="element-89">
                <span className="text-sm uppercase tracking-widest font-medium" data-id="element-90">
                  Professional Headshot
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24" data-id="element-91">
          <h2 className="text-2xl font-bold mb-10" data-id="element-92">Skills & Expertise</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-93">
            {skills.map((skillGroup, index) => <motion.div key={skillGroup.category} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-94">
                <h3 className="text-sm font-semibold tracking-widest text-gray-400 uppercase mb-6 border-b border-gray-100 pb-4" data-id="element-95">
                  {skillGroup.category}
                </h3>
                <ul className="space-y-3" data-id="element-96">
                  {skillGroup.items.map(item => <li key={item} className="font-medium text-gray-900" data-id="element-97">
                      {item}
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </div>;
}